import { render, staticRenderFns } from "./PerformanceImprovementDetails.vue?vue&type=template&id=c816e2c4&scoped=true"
import script from "./PerformanceImprovementDetails.vue?vue&type=script&lang=js"
export * from "./PerformanceImprovementDetails.vue?vue&type=script&lang=js"
import style0 from "./PerformanceImprovementDetails.vue?vue&type=style&index=0&id=c816e2c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c816e2c4",
  null
  
)

export default component.exports